import api from "../../services/api";
import { io } from "socket.io-client";

let chatSocket = null;
let callingSocket = null;

const getSignature = () => localStorage.getItem("signature");

const withSignature = (data = {}) => ({
  ...data,
  signature: getSignature(),
});

export const getAllUsers = async () => {
  return api.post("userService/getAllEmployeesListData", withSignature());
};

export const getUserChannels = async () => {
  return api.post("/chatService/getChannels", withSignature());
};

// ─── Shared socket options ─────────────────────────────────────────────────

const getAuthOptions = () => ({
  auth: {
    token: localStorage.getItem("token"),
    signature: localStorage.getItem("signature"),
  },
  // ✅ Both transports — ngrok works better with polling as fallback
  transports: ["websocket", "polling"],
  // ✅ Required for ngrok free tier — skips the browser warning interstitial
  extraHeaders: {
    "ngrok-skip-browser-warning": "true",
  },
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 1000,
  timeout: 20000,
});

// ─── Chat socket ───────────────────────────────────────────────────────────

export function initializeSocket() {
  const token = localStorage.getItem("token");
  const signature = localStorage.getItem("signature");

  if (!token || !signature) {
    console.error("Missing token or signature in localStorage");
    return null;
  }

  if (!chatSocket) {
    const socketUrl = process.env.REACT_APP_API_SOCKET_URL;

    chatSocket = io(socketUrl, {
      ...getAuthOptions(),
      path: "/socket.io",
    });

    chatSocket.on("connect", () => {});

    chatSocket.on("disconnect", (reason) => {});

    chatSocket.on("connect_error", (err) => {
      console.error("❌ Chat socket error:", err.message);
    });
  }

  return chatSocket;
}

// ─── Calling socket ────────────────────────────────────────────────────────

export function initializeCallingSocket() {
  const token = localStorage.getItem("token");
  const signature = localStorage.getItem("signature");
  const userId = localStorage.getItem("userId");
  const numericUserId = userId ? parseInt(userId, 10) : null;

  if (!token || !signature) {
    console.error("❌ Missing token or signature");
    return null;
  }

  if (!callingSocket) {
    const socketUrl = process.env.REACT_APP_API_SOCKET_URL;

    callingSocket = io(socketUrl, {
      ...getAuthOptions(),
      path: "/calling.io",
    });

    callingSocket.on("connect", () => {
      // Join the calling system with numeric user ID
      setTimeout(() => {
        callingSocket.emit(
          "join-calling",
          { userId: numericUserId },
          (response) => {
            if (response?.success) {
            } else {
              console.error("❌ Failed to join calling system:", response);
            }
          },
        );
      }, 500);
    });

    callingSocket.on("disconnect", (reason) => {});

    callingSocket.on("connect_error", (err) => {
      console.error("❌ Calling socket error:", err.message);
    });
  }

  return callingSocket;
}

// ─── Getters ───────────────────────────────────────────────────────────────

export function getSocket() {
  return chatSocket;
}

export function getCallingSocket() {
  return callingSocket;
}

// ─── Disconnect ────────────────────────────────────────────────────────────
export function disconnectChatSocket() {
  if (chatSocket) {
    chatSocket.disconnect();
    chatSocket = null;
  }
}

/**
 * Disconnect BOTH sockets. Only use this on app-level shutdown / logout.
 */
export function disconnectSocket() {
  disconnectChatSocket();
  if (callingSocket) {
    callingSocket.disconnect();
    callingSocket = null;
  }
}
